"use client";

import config from "@/config/environment";

export type LaunchDarklyClientContext = {
  sessionReplayUrl: string | null;
  sessionReplayUrlAtError: string | null;
  serviceName: string;
  environment: string;
  appVersion: string;
};

const resolveLdEnvironment = (): string => {
  const fromEnv = process.env.NEXT_PUBLIC_LAUNCHDARKLY_OBSERVABILITY_ENVIRONMENT?.trim();
  if (fromEnv) {
    return fromEnv;
  }
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "preview") {
    return "preview";
  }
  if (process.env.NODE_ENV !== "production") {
    return "development";
  }
  return "production";
};

export const collectLaunchDarklyClientContext =
  async (): Promise<LaunchDarklyClientContext> => {
    const ld = config.client.launchDarkly;
    const base: LaunchDarklyClientContext = {
      sessionReplayUrl: null,
      sessionReplayUrlAtError: null,
      serviceName: ld.serviceName,
      environment: resolveLdEnvironment(),
      appVersion: ld.version,
    };
    if (typeof window === "undefined") {
      return base;
    }
    try {
      const { LDRecord } = await import("@launchdarkly/session-replay");
      if (typeof LDRecord.getSession !== "function") {
        return base;
      }
      const session = await LDRecord.getSession();
      return {
        ...base,
        sessionReplayUrl:
          typeof session?.url === "string" ? session.url : null,
        sessionReplayUrlAtError:
          typeof session?.urlWithTimestamp === "string"
            ? session.urlWithTimestamp
            : null,
      };
    } catch {
      return base;
    }
  };

export const resolveClientRoute = (): string => {
  if (typeof window === "undefined") {
    return "";
  }
  return `${window.location.pathname}${window.location.search}`;
};
